import { render, staticRenderFns } from "./post-prod.vue?vue&type=template&id=31a9dbc9&"
import script from "./post-prod.vue?vue&type=script&lang=js&"
export * from "./post-prod.vue?vue&type=script&lang=js&"
import style0 from "./post-prod.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports